import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import AboutUs from '@/pages/aboutUs'
import ContactUs from '@/pages/contactUs'
import JoinUs from '@/pages/joinUs'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/aboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/contactUs',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/joinUs',
      name: 'JoinUs',
      component: JoinUs
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js